import { render, staticRenderFns } from "./Logmon.vue?vue&type=template&id=6bb1fd9b"
import script from "./Logmon.vue?vue&type=script&lang=ts"
export * from "./Logmon.vue?vue&type=script&lang=ts"
import style0 from "./Logmon.vue?vue&type=style&index=0&id=6bb1fd9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports